var _themes;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import tscStyles from '../constants/TscStyles';
import ControlButton from '../ControlButton/ControlButton';
import TscThemeName from '../constants/TscThemeName';
import { getClassName } from '../utils/get-class-name';
import TscButtonType from '../constants/TscButtonType';
var themes = (_themes = {}, _defineProperty(_themes, TscThemeName.dawn, {
  text: {
    color: tscStyles.color.text.mediumDark
  },
  title: {
    color: tscStyles.color.text.mediumDark
  }
}), _defineProperty(_themes, TscThemeName.dusk, {
  text: {
    color: tscStyles.color.text.lightMedium
  },
  title: {
    color: tscStyles.color.text.light
  }
}), _themes);
var Container = styled.div.attrs(function (props) {
  return props.testId ? {
    'data-test-id': props.testId
  } : {};
}).withConfig({
  displayName: "EmptyState__Container"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;font-family:'Proxima Nova','proxima-nova',sans-serif;padding:1rem;width:100%;text-align:center;"]);
var ImageContainer = styled.div.withConfig({
  displayName: "EmptyState__ImageContainer"
})([""]);
var TitleContainer = styled.div.withConfig({
  displayName: "EmptyState__TitleContainer"
})(["font-weight:600;font-size:1.25rem;margin-bottom:.5rem;color:", ";"], function (props) {
  return themes[props.themeName].title.color;
});
var TextContainer = styled.div.withConfig({
  displayName: "EmptyState__TextContainer"
})(["font-weight:400;margin-bottom:1rem;line-height:1.4;color:", ";"], function (props) {
  return themes[props.themeName].text.color;
});
var ButtonsContainer = styled.div.withConfig({
  displayName: "EmptyState__ButtonsContainer"
})(["> *{margin-right:.5rem;&:last-child{margin-right:0;}}"]);
var defaultProps = {
  maxWidth: '24rem',
  primaryButtonText: '',
  primaryButtonType: TscButtonType.primary,
  themeName: TscThemeName.dusk
};

var EmptyState = function EmptyState(props) {
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      alt = _defaultProps$props.alt,
      className = _defaultProps$props.className,
      imageSource = _defaultProps$props.imageSource,
      maxWidth = _defaultProps$props.maxWidth,
      onPrimaryClick = _defaultProps$props.onPrimaryClick,
      primaryButtonText = _defaultProps$props.primaryButtonText,
      primaryButtonType = _defaultProps$props.primaryButtonType,
      testId = _defaultProps$props.testId,
      text = _defaultProps$props.text,
      themeName = _defaultProps$props.themeName,
      title = _defaultProps$props.title; // overlay the defaultProps and passed in props in logical order and spread to constant values


  var imgStyle = {
    maxWidth: maxWidth,
    maxHeight: maxWidth,
    userSelect: 'none',
    width: '100%',
    objectFit: 'contain',
    marginBottom: '1rem'
  };
  var widthStyle = {
    maxWidth: maxWidth
  };
  return _jsxs(Container, {
    className: getClassName(className, null, 'empty-state-container'),
    testId: testId,
    children: [imageSource && _jsx(ImageContainer, {
      className: getClassName(className, 'image-container'),
      children: _jsx("img", {
        style: imgStyle,
        src: imageSource,
        title: title,
        alt: alt
      })
    }), title && _jsx(TitleContainer, {
      className: getClassName(className, 'title-container'),
      style: widthStyle,
      themeName: themeName,
      children: title
    }), text && _jsx(TextContainer, {
      className: getClassName(className, 'text-container'),
      style: widthStyle,
      themeName: themeName,
      children: text
    }), onPrimaryClick && _jsx(ButtonsContainer, {
      className: getClassName(className, 'buttons-container'),
      style: widthStyle,
      themeName: themeName,
      children: _jsx(ControlButton, {
        className: getClassName(className, 'primary'),
        themeName: themeName,
        buttonType: primaryButtonType,
        label: primaryButtonText,
        onClick: onPrimaryClick
      })
    })]
  });
};

EmptyState.defaultProps = defaultProps;
var EmptyStateTest = {
  Container: Container
};
export { EmptyState, EmptyStateTest };
export default EmptyState;